<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <!-- National Code input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'waterAuthorities.nationalCode' | translate }}</mat-label>
      <input matInput formControlName="nationalCode" data-test="water-authority-national-code" />
      @if (formGroup.controls.nationalCode.hasError('required')) {
        <mat-error> {{ 'waterAuthorities.nationalCode' | translate }} is required </mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Is Active toggle -->
  <div class="flex--row flex--gutter">
    <div class="mat-slide-group-wrapper flex__child--auto">
      <div class="mat-slide-group mat-slide-group--match-form-field-size">
        <mat-slide-toggle color="primary" formControlName="isActive" data-test="water-authority-is-active">
          {{ 'waterAuthorities.isActive' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>

  <!-- Display Name input -->
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
      <mat-label>{{ 'waterAuthorities.displayName' | translate }}</mat-label>
      <input matInput formControlName="displayName" data-test="water-authority-display-name" />
      @if (formGroup.controls.displayName.hasError('required')) {
        <mat-error> {{ 'waterAuthorities.displayName' | translate }} is required </mat-error>
      }
    </mat-form-field>
  </div>
</agr-form-dialog>
